import {
  validateErrors,
  required,
  maxLength,
  email,
} from '../validators';


const validate = (values) => {
  const validators = {
    email: [maxLength(200), email, required],
  };
  return validateErrors(values, validators);
};

export default validate;
